import { render, staticRenderFns } from "./billing-summary-status.vue?vue&type=template&id=3c5ba0bc"
import script from "./billing-summary-status.vue?vue&type=script&lang=js"
export * from "./billing-summary-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c5ba0bc')) {
      api.createRecord('3c5ba0bc', component.options)
    } else {
      api.reload('3c5ba0bc', component.options)
    }
    module.hot.accept("./billing-summary-status.vue?vue&type=template&id=3c5ba0bc", function () {
      api.rerender('3c5ba0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/modules/invoice/components/billing-summary-status.vue"
export default component.exports